export class StripeBankInfoResponse
{
    chargesEnabled: boolean;
    payoutsEnabled: boolean;
    message: string;
    bankInfo: BankAccountInfo;

    public constructor(init?: Partial<StripeBankInfoResponse>) {
        Object.assign(this, init);
        if ( this.bankInfo ) {
            this.bankInfo = new BankAccountInfo(this.bankInfo);
        }
    }
}

export class BankAccountInfo {
    id: string;
    object: string;
    account: string;
    accountId: string;
    accountHolderName: string;
    accountHolderType: string;
    accountType: string;
    availablePayoutMethods: string[];
    bankName: string;
    country: string;
    currency: string;
    defaultForCurrency: boolean;
    fingerprint: string;
    last4: string;
    routingNumber: string;
    status: string;
    completed: boolean;

    public constructor(init?: Partial<BankAccountInfo>) {
        Object.assign(this, init);
    }
}

export enum DepositStatus {
    Pending = 1,
    Started = 2,
    Completed = 3,
    Cancelled = 4
}

export class Deposit {
    depositId: number;
    raffleId: number;
    stripeAccountId: string;
    amount: number;
    status: DepositStatus;
    timestamp: Date;

    public constructor(init?: Partial<Deposit>) {
        Object.assign(this, init);
    }
}


